import React from "react";
import { Wrap } from "./styles";

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: "submit" | "button" | "reset";
}

const IconButton = ({
  type = "button",
  children,
  ...rest
}: IconButtonProps) => {
  return (
    <Wrap {...rest} type={type}>
      {children}
    </Wrap>
  );
};

export default IconButton;
